import { Button } from '@chakra-ui/react'
import React from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import useFile from '@/features/files/useFile'
import { hideLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

const ViewFileButton = ({ colorScheme = 'blue', fileName, fileId, viewOnSharePoint = false }) => {
  const { id } = useParams()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { useDownloadFile, useViewFileOnSharepoint } = useFile()
  const downloadFile = useDownloadFile()
  const { data: sharepointTenderData, refetch } = useViewFileOnSharepoint(id)

  const handleViewFile = async () => {
    try {
      // //for tender file, view on sharepoint directly
      // if (viewOnSharePoint) {
      //   const file = sharepointTenderData.find((file) => file.name.includes(fileName))
      //   window.open(file.webUrl)
      // } else {

      // }

      const response = await downloadFile.mutateAsync(fileId)
      const fileType = response.headers['content-type']

      if (fileType === 'application/pdf') {
        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        })

        const fileUrl = URL.createObjectURL(blob)

        window.open(fileUrl)
      } else {
        toast.error("This file type can't be preview, please download it instead.")
        return
      }
    } catch (err) {
      toast.error(`${err}`)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  return (
    <Button
      colorScheme={colorScheme}
      onClick={(e) => {
        e.stopPropagation()

        handleViewFile()
      }}
    >
      {t('BUTTON_VIEW')}
    </Button>
  )
}

export default ViewFileButton
